// 語言
export const LangStrMap = ['zh-CN', 'zh-HK', 'en-US']

// 語言
export const LangOptionsMapArr = [
  {
    value: 'zh-CN',
    label: '中文(简)',
  },
  {
    value: 'zh-HK',
    label: '中文(繁)',
  },
  {
    value: 'en-US',
    label: 'English',
  },
]
